import React, { useEffect } from "react";
import { motion } from "motion/react";
import { useCursor } from "../../context/cursorUtils";

interface EndScreenProps {
  isAnimated: boolean;
}

export const EndScreen: React.FC<EndScreenProps> = ({ isAnimated }) => {
  const { setIsMorphed, setMorphStyle, setHoverText, setIsHovering } =
    useCursor();
  // Handle cursor changes based on animation state
  useEffect(() => {
    if (!isAnimated) {
      // Reset cursor when component animates out of view
      setIsHovering(false);
      setIsMorphed(false);
      setHoverText("");
    } else {
      // Apply cursor changes when component animates into view
      // This handles the case where the cursor is already over the component
      // when it animates in (e.g., when scrolling down to footer)
      setMorphStyle({
        backgroundColor: "#00ffff",
        width: "40px",
        height: "40px",
        clipPath: "circle(50% at 50% 50%)",
        scale: 2,
      });
      setIsHovering(true);
      setIsMorphed(true);
      setHoverText("Scroll");
    }
  }, [isAnimated, setIsMorphed, setHoverText, setMorphStyle, setIsHovering]);

  const handleMouseOver = () => {
    if (isAnimated) {
      setMorphStyle({
        backgroundColor: "#00ffff",
        width: "40px",
        height: "40px",
        clipPath: "circle(50% at 50% 50%)",
        scale: 2,
      });
      setIsHovering(true);
      setIsMorphed(true);
      setHoverText("Scroll");
    }
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setIsMorphed(false);
    setHoverText("");
  };

  return (
    // <div
    //   // onClick={handleClick}
    //   className="w-screen h-screen relative overflow-hidden font-nyght-serif-light-italic font-[700]"
    // >
    <div
      className="end-screen"
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      {/* Left div - enters from left */}
      <motion.div
        initial={{ x: "-60vw" }}
        animate={
          isAnimated
            ? {
                x: "-10vw",
              }
            : {
                x: "-60vw",
              }
        }
        transition={{
          type: "spring",
          stiffness: 100,
          damping: 17.5,
          duration: 1.5,
        }}
        className="bg-[#D60000] font-nyght-serif-medium-italic w-[60vw] left-0 h-full pr-2 fixed top-0 flex flex-col justify-center items-end text-white text-4xl"
      >
        <span className="xl:-mt-10 lg:-mt-8 md:-mt-6 -mt-4 xl:text-[120px] lg:text-[100px] md:text-[70px] text-[40px] xl:leading-26 lg:leading-22 md:leading-16 leading-10">
          Let’s
        </span>
        <div className="flex items-center gap-8">
          <span className="xl:text-[120px] lg:text-[100px] md:text-[70px] text-[40px] xl:leading-26 lg:leading-22 md:leading-16 leading-10">
            Stories
          </span>
        </div>
      </motion.div>
      {/* Right div - enters from right */}
      <motion.div
        initial={{ x: "60vw" }}
        animate={
          isAnimated
            ? {
                x: "10vw",
              }
            : {
                x: "60vw",
              }
        }
        transition={{
          type: "spring",
          stiffness: 100,
          damping: 17.5,
          duration: 1.5,
        }}
        className="bg-[#D60000] font-nyght-serif-medium-italic w-[60vw] right-0 fixed top-0 h-full flex flex-col justify-center text-white text-4xl"
      >
        <div className="xl:mt-10 lg:mt-8 md:mt-6 mt-4 flex items-center gap-8-ml-2">
          <span className="xl:text-[120px] lg:text-[100px] md:text-[70px] text-[40px] xl:leading-26 lg:leading-22 md:leading-16 leading-10">
            Create
          </span>
        </div>{" "}
        <span className="xl:text-[120px] -ml-2 lg:text-[100px] md:text-[70px] text-[40px] xl:leading-26 lg:leading-22 md:leading-16 leading-10">
          Together
        </span>
      </motion.div>
    </div>
  );
};
